<template>
  <div class="d-flex">
    <div class="px-2">
      <v-btn style="text-transform: capitalize" width="100%" small color="info" @click="contractToWordDownload">
        <v-icon class="mr-2">fas fa-download</v-icon>
        Скачать договор
      </v-btn>
    </div>
    <div class="px-2">
      <v-btn style="text-transform: capitalize" width="100%" small color="info" @click="downloadContract">
        <v-icon class="mr-2">fas fa-print</v-icon>
        Печатать договор
      </v-btn>
    </div>
    <div v-if="contractData" style="display: none" id="contract-credit-print-page">
      <div class="a4__size">
        <div class="agreement__block">
          <h2 class="block__title">ШАРТНОМА № {{ contractData.credit_number }}</h2>
          <h3 class="block__subtitle">Махсулотни ҳақини бўлиб тўлаш шарти билан олди-сотди</h3>
          <p class="block__date">{{ contractData.start_date |parseDate }} й.</p>

          <p class="block__text">
            Бир тарафдан {{ contractData.mko_name }} нинг низоми асосида фаолият юритувчи рахбари
            {{ contractData.mko_director }}
            (кейинги уринларда "Сотувчи" деб аталади) ва да яшовчи
            {{ contractData.first_name }} {{ contractData.last_name }} {{ contractData.mid_name }} (Паспорт серия
            {{ contractData.passport_series }} {{ contractData.passport_number }} {{ contractData.passport_issue_date }}
            берилган) (кейинги уринда "ХАРИДОР" деб аталади) иккинчи томондан ушбу шартномани тарафлар уртасида узаро
            келишув асосида куйидагилар тугрисида тузилди.
          </p>

          <h2 class="block__title">1.ШАРТНОМА ПРЕДМЕТИ</h2>

          <p class="block__text">1.1. "СОТУВЧИ" куйидаги махсулотларни "ХАРИДОР"га махсулотни узоро келишув асосида
            {{ contractData.period }} ой муддат давомида кийматини булиб тулаш шарти билан сотади, ушбу махсулотлар
            тулов
            шартлари
            тулик бажарилиб , туловлар тулик тулангандан сунг "ХАРИДОР"ни шахсий мулкига айланади.</p>

          <div class="table__main agreement__table">
            <table border="1" width="100%" cellpadding="5" cellspacing="0">
              <tr>
                <td style="width: 80px; font-size: 12px;">№</td>
                <td style="font-size: 12px">Махсулот номи</td>
                <td style="font-size: 12px">Улчов
                  бирлиги
                </td>
                <td style="font-size: 12px">Микдори</td>
                <td style="font-size: 12px">Нархи</td>
                <td style="font-size: 12px">Суммаси</td>
              </tr>
              <td style="font-size: 12px">1</td>
              <td style="font-size: 12px">{{contractData.details}}</td>
              <td style="font-size: 12px">дона</td>
              <td style="font-size: 12px">1</td>
              <td style="font-size: 12px">{{ contractData.old_amount }}</td>
              <td style="font-size: 12px">{{ contractData.old_amount }}</td>
            </table>
          </div>

          <div class="total__price">
            <b>Жами махсулот суммаси:</b>
            <span>{{ contractData.old_amount }}</span>
          </div>


          <h2 class="block__title">2.ШАРТНОМА СУММАСИ ВА ТУЛОВ ШАРТЛАРИ</h2>

          <p class="block__text">
            2.1. Мазкур шартнома суммаси куйидаги жадвал буйича аникланди.
          </p>

          <div class="table__main agreement__table">
            <table border="1" width="100%" cellpadding="5" cellspacing="0">
              <tr>
                <td style="font-size: 12px">Товар суммаси</td>
                <td style="font-size: 12px">Ойма-ой тулови</td>
                <td style="font-size: 12px">Олдиндан тулов суммаси</td>
                <td style="font-size: 12px">Колдик карз суммаси</td>
                <td style="font-size: 12px">Булиб тулаш шартномаси муддати</td>
              </tr>
              <tr>
                <td style="font-size: 12px">{{ contractData.old_amount }} сўм</td>
                <td style="font-size: 12px">{{ contractData.main_residue }} сўм</td>
                <td style="font-size: 12px">{{ contractData.initial_payment }} сўм</td>
                <td style="font-size: 12px">{{ contractData.amount }} сўм</td>
                <td style="font-size: 12px">{{ contractData.period }} ой</td>
              </tr>
            </table>
          </div>

          <p class="block__text tdu">
            {{ contractData.old_amount }} сўм 00 тийин ташкил этади.
          </p>

          <p class="block__text">
            2.2. Сотиб олинаётган махсулот нархининг колган кисмини "ХАРИДОР" уз ойлик иш хакисидан ёки бошка
            даромадлари
            хисобидан ушбу шартномага илова килинган тулов жадвали буйича тулаб беради.
          </p>

          <h2 class="block__title">
            3.ШАРТНОМА ХУКУК ВА МАЖБУРИЯТЛАРИ.
          </h2>

          <p class="block__text obligations__name">
            3.1. "СОТУВЧИ" хукуклари:
          </p>

          <ul class="block__ul">
            <li>• "СОТУВЧИ" "ХАРИДОР" га аввал фойдаланилмаган янги ва бут товар билан таъминлайди;</li>
            <li>• "СОТУВЧИ" "ХАРИДОР" дан харид килинаётган товарини булиб тулашга кобиллиги , оила аъзоларининг
              розилиги
              , оиладаги молиявий холатни урганиш ва тахлил килиш;
            </li>
            <li>• "СОТУВЧИ" куйидаги холатларда "ХАРИДОР" билан шартномани муддатидан олдин бекор килиши мумкин:</li>
            <li>- "ХАРИДОР" туловларни мунтазам равишда кечиктирса;</li>
            <li>- "ХАРИДОР" товарни тулик киймати туламагунча кадар 3-шахсга утказса (сотиб ёки ижарага бериб юборса);
            </li>
            <li>- "ХАРИДОР" 60 кун давомида умуман туловни амалга оширмаса;</li>
            <li>- "ХАРИДОР" айби билан товар бутлигига зиён етказилса;</li>
            <li>• "ХАРИДОР" сотиб олинган махсулотлар учун туловларни тулаш муддатидан кечиктирган такдирда ,
              кечиктирилган карзига нисбатан утиб кетган хар бир куни учун 0,5% пеня хисоблаш.
            </li>
          </ul>

          <p class="block__text obligations__name">3.2. "СОТУВЧИ" нинг мажбуриятлари:</p>

          <ul class="block__ul">
            <li>"ХАРИДОР" сотиб олинаётган махсулотнинг олдиндан туловини амалга оширишдан сунг 15 кун муддат ичида ушбу
              махсулотни булигини ва тулалигини таъминлаш
            </li>
          </ul>

          <p style="margin-bottom: 25px;"></p>

          <p class="block__text obligations__name">3.3. "ХАРИДОР" нинг хукуклари:</p>

          <ul class="block__ul">
            <li>Ушбу шартномага асосан сотиб олинаётган махсулотларни олдиндан тулови тулангандан сунг 15 кун муддат
              ичида
              ушбу махсулотларни талаб килиш ва уз хисобидан олиб кетиш.
            </li>
          </ul>


          <p class="block__text obligations__name">3.4. "ХАРИДОР" нинг мажбуриятлари:</p>

          <ul class="block__ul">
            <li>• "СОТУВЧИ"дан сотиб олинрган махсулотлар учун туловларни уз вактида амалга ошириш.</li>
            <li>• Махсулотлардан тулов муддати тугагунча кадар белгиланган тартибда фойдаланиш, бутлигини таъминлаш.
            </li>
            <li>• Махсулотларни киймати тулик туланмагунча кадар ушбу махсулотларни сотмаслик хамда бошка келишувларни
              амалга оширмаслик.
            </li>
          </ul>

          <p class="block__text agreement__mt"> Шартнома шартлари билан танишиб чикдим. Ушбу шартнома шартларига
            розиман_______________________ </p>

          <p></p>
          <h2 class="block__title">4.ТОМОНЛАР ЖАВОБГАРЛИГИ.</h2>

          <ul class="block__ul">
            <li>4.1. Томонлар ушбу шартнома шартларини бажармаслик ва белгиланган шартларга риоя килмасдан бажарган холда
              амалдаги конунчилик олдида жавобгардилар.
            </li>
            <li>4.2. Ушбу шартнома шартларини бажармаслиги окибатида юзага келган низоли вазиятлар Узбекистон Республикасининг
              амалдаги конун хужжатларига амал килган холда музокаралар йули билан хал киладилар. Томонлар келишувига эришилмаган
              такдирда низолар суд органлари <b>ва нотариус оркали</b> хал килинади.
            </li>
            <li>4.3. "ХАРИДОР" сотиб олинган махсулотлар учун туловларни тулов жадвалига асосан 2 ёки ундан ортик холатда, муддатидан утказиб юборса «сотувчининг биринчи талаби билин 10 кун муддатда сотиб олинган махсулот юзасидан  мавжуд карздорликни тулик хисоб-китобини амалга оширади».                  Хисоб-китобни амалга оширмаган такдирда мазкур шартноманинг  4.2. бандига асосан «Сотувчи» «Харидордан» ундириб олиш учун кетган харажатларни кушган холда ундириб олишга хакли.
            </li>
            <li>4.4. ХАРИДОР ўз хоҳишига кўра тўловни нақд пул шаклида {{ contractData.user_cards ? 'ёки ' + contractData.user_cards + " рақамли банк пластик картасидан" : '' }}  амалга оширади.
              Тўлов мазкур банднинг 1-қисмида назарда тутилмаган банк пластик картасидан амалга оширилган тақдирда
              ХАРИДОР
              бу тўловнинг қонунийлигини кафолатлайди ҳамда бунинг оқибати бўйича ҳар қандай турдаги масъулият ва
              жавобгарликни ўз зиммасига олади.
            </li>
            <li>4.5. СОТУВЧИ тўлов муддати келган ва жадвалида назарда тутилган тўловни, шунингдек тўлов кечиктирилиши
              муносабати билан ҳисобланган пеня суммасини ХАРИДОРнинг {{contractData.user_cards ? contractData.user_cards : ''}} рақамли банк
              пластик картаси ҳисобварағидан сўзсин ундириб олишга ҳақли.
            </li>
            <li>4.6. Сотувчи менга, яъни {{ contractData.user_cards ? contractData.user_cards :'' }} банк пластик картасига тегишли ҳисобварақдан пул тўловларини сўзсиз
              ечиб олинишига розиман.
            </li>
          </ul>

          <h2 class="block__title">5.БОШКА ШАРТЛАР.</h2>
          <ul class="block__ul">
            <li>5.1. Ушбу шартномага барча узгартириш ва кушимчалар томонлар имзолаган кушимча битим тарзида ёзма шаклда
              расмийлаштирилади.
            </li>
            <li>5.2. Ушбу шартномада кузда тутилмаган холатлар юзасидан томонлар амалдаги конунчиликка асосан иш
              курадилар.
            </li>
            <li>5.3. Ушбу шартнома "ХАРИДОР" томонидан махсулотлар тулик кабул килиб олинган вактдан бошлаб кучга киради
              ва ушбу шартнома буйича мажбуриятлар тулик бажарилгунига кадар амал килади.
            </li>
            <li>5.4. Ушбу шартнома хар кайси томон учун бир хил юридик кучга эга булган икки нусхада тузилди.</li>
          </ul>

          <h2 class="block__title">6.ТОМОНЛАРНИНГ МАНЗИЛЛАРИ.</h2>
          <div style="margin-top: 50px"></div>
          <div class="address__main">
            <div class="address__column address__left">
              <div class="address__name">"СОТУВЧИ":</div>

              <div class="table__main">
                <table border="1" cellpadding="5" cellspacing="0" width="100%">
                  <tbody>
                  <tr>
                    <td width='70'>Номи:</td>
                    <td>{{ contractData.mko_name }}</td>
                  </tr>
                  <tr>
                    <td width='70'>Манзили:</td>
                    <td>{{ contractData.mko_address }}</td>
                  </tr>

                  <tr>
                    <td width='70'>Банк:</td>
                    <td>{{ contractData.mko_bank }}</td>
                  </tr>

                  <tr>
                    <td width='70'>Х/Р:</td>
                    <td>{{ contractData.mko_xr }}</td>
                  </tr>

                  <tr>
                    <td width='70'>МФО</td>
                    <td>{{ contractData.mko_mfo }}</td>
                  </tr>

                  <tr>
                    <td width='70'>ИНН:</td>
                    <td>{{ contractData.mko_inn }}</td>
                  </tr>

                  <tr>
                    <td width='70'>Телефон:</td>
                    <td>{{ contractData.mko_phone }}</td>
                  </tr>

                  <tr>
                    <td width='70'>Рахбар:</td>
                    <td>{{ contractData.mko_director }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <p class="address__text">
                <b>Сотувчи имзоси:</b>
                <span>___________</span>
              </p>
            </div>

            <div class="address__column address__right">
              <div class="address__name">"ХАРИДОР":</div>

              <div class="table__main">
                <table border="1" cellpadding="5" cellspacing="0" width="100%">
                <tbody>
                  <tr>
                    <td width='70'>Номи:</td>
                    <td>{{ contractData.first_name }} {{ contractData.last_name }} {{ contractData.mid_name }}</td>
                  </tr>
                  <tr>
                    <td width='70'>Паспорт
                      маълумотлари:
                    </td>
                    <td>{{ contractData.passport_series }} {{ contractData.passport_number }}
                      {{ contractData.passport_issue_date }} да берилган.
                    </td>
                  </tr>

                  <tr>
                    <td width='70'>Адрес:</td>
                    <td>{{ contractData.live_address }}</td>
                  </tr>

                  <tr>
                    <td width='70'>ИНН:</td>
                    <td>{{ contractData.inn }}</td>
                  </tr>

                  <tr>
                    <td width='70'>Телефон:</td>
                    <td>{{ contractData.user_phone }}</td>
                  </tr>
                  <tr v-if="contractData.user_cards">
                    <td width='70'>Банк канрталари:</td>
                    <td>{{ contractData.user_cards }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <p class="address__text">
                <b>Харидор имзоси:</b>
                <span>___________</span>
              </p>

            </div>
          </div>

          <p class="block__text agreement__mt"
             style="text-align: left">
            Шартнома шартлари билан танишиб чикдим. Ушбу шартнома шартларига розиман_______________________
          </p>


        </div>
      </div>
    </div>
  </div>
</template>

<script>


import {downloadTextFile, htmlToWord} from "@/utils/pureFunctions";
import printCssText from "@/components/credit/printCssText";

export default {
  name: 'DownloadContractButton',
  props: {
    credit_id: {required: true}
  },
  data() {
    return {
      contractData: null
    }
  },
  methods: {
    getData() {
      return this.$http.get(`admin/credit/invoice/${this.credit_id}`).then(({data: {data}}) => {
        this.contractData = data
      })
    },
    async downloadContract() {
      try {
        this.$showLoading()
        await this.getData()
        this.$nextTick(() => {
          this.$htmlToPaper('contract-credit-print-page')
        })
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
    async contractToWordDownload() {
      await this.getData()
      this.$nextTick(() => {
        const wordSrc = htmlToWord(document.getElementById('contract-credit-print-page').innerHTML, printCssText)
        downloadTextFile('contract.doc', wordSrc)
      })
    }
  }
}
</script>
